import { useEffect, useState } from "react";
import LoadingStuck from "../../reuse/LoadingStuck";
import Api from "../../../api/Api";
import { useParams } from "react-router";
import { Accordion, Button, Card, Dropdown, Form, Modal, Tab, Table, Tabs } from "react-bootstrap";
import countByFormulaTotal from "../../reuse/countByFormulaTotal";
import { auditTypes } from "../../../constants/auditTypes";
import { ShortNamesOfTestCategories } from "../../reuse/ShortNamesOfTestCategories";
import { tableDataTransform } from "../../reuse/ExcelTableDataTransform";
import ComparisonGraficBarChar from "../../reuse/ComparisonGraficBarChar";
import { GraficBarChar } from "../../reuse/GraficBarChar";
import { downloadExcelAuditResults } from "../../reuse/downloadExcelAuditResults";
import downloadJsonFile from "../../reuse/downloadJsonFile";


const tableColumnsLabels = {
    "part_name":"Раздел",
    "category":"Подраздел",
    "auditor":"Аудиторы",
    "level":"Уровень",
    "task":"Пункт",
    "task_number":"Номер",
    "answer":"Ответ",
    "comment":"Комментарий",
    "taskText":"Текст задания",
    "taskControlElement":"Контрольный элемент",
    "esteem_result":"Результат самоаудита",
    "esteem_comment":"Комментарий самоаудита"} 

const ScoreBlock = ({data, shortNames})=> {
    return(
        <>
        <Card className="mb-2">
            <Card.Body>
                <h2>Общая оценка: {data.summary}</h2>
            </Card.Body>
        </Card>
        <Accordion defaultActiveKey="none" flush className="border">
            {data.data_count.map((partName, index)=>(
                <Accordion.Item eventKey={index} key={index}>
                    <Accordion.Header><div className="text_font">{partName.name} -- {partName.value}</div></Accordion.Header>
                    <Accordion.Body>
                        <ul className="text_font">{Object.keys(partName.category_scors).map((categoryName)=>(
                            <li> {shortNames[partName.name][categoryName]}. {categoryName} -- {partName.category_scors[categoryName]}</li>
                        ))}</ul>
                    </Accordion.Body>
                </Accordion.Item>
            ))}
        </Accordion>
        </>
    )
}

const TableDataInterface = ({dataTable}) => {
    if(dataTable.length==0){
        return(<p>"Данных нет."</p>)
    }
    const dataColumns=Object.keys(dataTable[0])
    return(
        <Table striped bordered size="sm" responsive>
            <thead>
                <tr>
                    {dataColumns.map((elem)=>(<th>{tableColumnsLabels[elem]}</th>))}
                </tr>
            </thead>
            <tbody>
                {dataTable.map((elem)=>{
                    return(<tr>{Object.keys(elem).map((value)=>{return(
                        <td>{elem[value]}</td>
                    )})}</tr>)
                })}
            </tbody>
        </Table>
    )
}

const TableWithFilters = ({dataTable}) => {
    const [tableData, setTableData]=useState(dataTable);

    const [partNameFilter, setPartNameFilter]=useState("");
    const [categoryNameFilter, setCategoryNameFilter]=useState("");
    const [levelFilter, setlevelFilter]=useState("");
    const [numberFilter, setNumberFilter]=useState("");
    const [auditorsFilter, setAuditorsFilter]=useState("");
    const [AnswersFilter, setAnswersFilter]=useState("");

    useEffect(()=>{
        const result_data = dataTable.filter((item)=>{
            if(partNameFilter!=="" && !item.part_name.toLowerCase().includes(partNameFilter.toLowerCase())) return false;
            if(categoryNameFilter!=="" && !item.category.toLowerCase().includes(categoryNameFilter.toLowerCase())) return false;
            if(levelFilter!=="" && !item.level.toLowerCase().includes(levelFilter.toLowerCase())) return false;
            if(numberFilter!=="" && !item.task_number.toLowerCase().includes(numberFilter.toLowerCase())) return false;
            if(auditorsFilter!=="" && !item.auditor.toLowerCase().includes(auditorsFilter.toLowerCase())) return false;
            return true;
        })
        setTableData(result_data)
    },[partNameFilter,categoryNameFilter,levelFilter,numberFilter, auditorsFilter])

    return(<>
        {/* {JSON.stringify(dataTable)} */}
        <Card className="mb-2">
            <Card.Header className="text_font">Фильтры</Card.Header>
            <Card.Body>
                <div className="d-flex justify-content-between align-items-center flex-nowrap mb-1 gap-2">
                    <Form.Control
                        onChange={(e)=>setPartNameFilter(e.target.value)}
                        type="search"
                        placeholder="Раздел..."/>
                    <Form.Control 
                        onChange={(e)=>setCategoryNameFilter(e.target.value)}
                        type="search"
                        placeholder="Подраздел..."/>
                    <Form.Control
                        onChange={(e)=>setlevelFilter(e.target.value)}
                        type="search"
                        placeholder="Уровень..."/>
                    <Form.Control
                        onChange={(e)=>setNumberFilter(e.target.value)}
                        type="search"
                        placeholder="Номер..."/>
                    <Form.Control 
                        onChange={(e)=>setAuditorsFilter(e.target.value)}
                        type="search"
                        placeholder="Аудитор..."/>
                </div>
            </Card.Body>
        </Card>
        <TableDataInterface dataTable={tableData}/>
    </>)
}

const TableDataResults =({data, dataTest, calculateData, shortNames}) => {
    const dataTable=tableDataTransform(data,dataTest,calculateData, shortNames);
    return(
        <>
        <TableWithFilters dataTable={dataTable}/>
        </>
    )

}

const FullInfo = ({data}) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const keys=["id","name","audit_type",
        "facility_name","start_datetime","end_datetime","esteem_audit_name","description",
        "test_name","is_archived",
        "audit_leader_full_name"]

    const labels={
        "audit_type":"Тип аудита",
        "esteem_audit_name":"Самоаудит",
        "id":"Id аудита",
        "name":"Название",
        "description":"Описание",
        "facility_name":"Предприятие",
        "test_name":"Название теста",
        "start_datetime":"Дата начала",
        "end_datetime":"Дата окончания",
        "is_archived":"В архиве",
        "audit_leader_full_name":"Лидер аудита"}

    return(
        <>
        <div>
        <Button className="border" variant="light" size="sm" onClick={handleShow}>Подробнее</Button>
        </div>
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
            <Modal.Title className="text_font">Полная информация</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text_font">
                {keys.map((elem)=>{
                    if (elem=="start_datetime" || elem=="end_datetime"){
                        return <><div><strong>{labels[elem]}: </strong>{new Date(data[elem]).toLocaleString()}</div><br/></>
                    }
                    if (elem=="audit_type"){
                        return <><div><strong>{labels[elem]}: </strong>{auditTypes[data[elem]]}</div><br/></>
                    }
                    return <><div><strong>{labels[elem]}: </strong>{data[elem]}</div><br/></>
                })}
            </Modal.Body>
        </Modal>
        </>
    )
}

const GraficModal = ({calculateData, calculateDataEsteem, dataPartNames}) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const renderGrafic = () =>{
        if(calculateDataEsteem!==null){
            const graficFirst={}
            calculateData.data_count.map((elem)=>{graficFirst[elem.name]=elem.value})
            const graficSecond={}
            calculateDataEsteem.data_count.map((elem)=>{graficSecond[elem.name]=elem.value})
            const mergedData = dataPartNames.map((elem)=>{
                return {
                    name:elem, valueFirst:graficFirst[elem] || 0, valueSecond:graficSecond[elem] || 0}
            })
            return(
                <> 
                <div className="p-3">
                    <ComparisonGraficBarChar data={mergedData} labels={{firstLabel:"Аудит",secondLabel:"Самоаудит"}}/>
                </div>
                </>
            )
            // return(<ComparisonGraficBarChar data={}/>)
        }else{
            const data=calculateData.data_count.map((elem)=>{return {name:elem.name, value:elem.value}})
            return(
            <>
                <div className="p-3">
                    <GraficBarChar data={data} label={"аудит"}/>
                </div>
                {/* <p>{JSON.stringify(data)}</p> */}
            </>
        )
        }
    }

    return(
        <>
        <Button className="border" variant="light" size="sm" onClick={handleShow}>График</Button>
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
            <Modal.Title>График</Modal.Title>
            </Modal.Header>
                {renderGrafic()}
            <Modal.Body>
            </Modal.Body>
        </Modal>
        </>
    )
}

const AuditResultsInterface = ({data, dataTest}) => {
    const calculateData=countByFormulaTotal(data.results, data.coefficients)
    const calculateDataEsteemProccess = () => {
        if(data.esteem_audit_id!==null){
            return(countByFormulaTotal(data.esteem_results, data.coefficients))
        }
        return(null)
    }
    const calculateDataEsteem=calculateDataEsteemProccess();
    const dataPartNames=Object.keys(dataTest.data)

    const shortNames=ShortNamesOfTestCategories(dataTest.data)
    return(
        <>
            <Card className="mb-2">
                <Card.Header>
                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                        <div className="text_font">Информация об аудите</div>
                        <div className="d-flex flex-wrap gap-2">
                            <Dropdown>
                                <Dropdown.Toggle variant="light" className="border" size="sm" id="dropdown-basic">Скачать</Dropdown.Toggle>
                                 <Dropdown.Menu size="sm">
                                    <Dropdown.Item onClick={()=>downloadExcelAuditResults(data.id)}>Excel</Dropdown.Item>
                                    {/* <Dropdown.Item onClick={()=>downloadJsonFile(data, `${data.name}.json`)}>Json</Dropdown.Item> */}
                                </Dropdown.Menu>
                            </Dropdown>
                            <FullInfo data={data}/>
                            <GraficModal 
                            calculateData={calculateData} 
                            calculateDataEsteem={calculateDataEsteem}
                            dataPartNames={dataPartNames}/>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body className="text_font">
                    <div><strong>Название:</strong> {data.name}</div>
                    <div><strong>Тип аудита:</strong> {auditTypes[data.audit_type]}</div>
                    <div><strong>Завод:</strong> {data.facility_name}</div>
                    <div><strong>Дата и время окончания:</strong> {new Date(data.end_datetime).toLocaleString()}</div>
                </Card.Body>
            </Card>
            <div>
                <Tabs
                    defaultActiveKey="score"
                    id="fill-tab-example"
                    className="mb-3"
                    fill
                    >
                    <Tab eventKey="score" title={`Общая оценка - ${calculateData.summary}`}>
                        <ScoreBlock data={calculateData} shortNames={shortNames}/>
                    </Tab>
                    <Tab eventKey="table" title="Таблица результатов">
                        <TableDataResults 
                        data={data} 
                        dataTest={dataTest} 
                        calculateData={calculateData} 
                        shortNames={shortNames}/>
                    </Tab>
                </Tabs>
            </div>
        </>
    )
}

const getAuditResults = async(audit_id) =>{
    try {
        const response=await Api({
            method:"get",
            url:`/audits/@${audit_id}/results`,
            headers:{}
        })
        return(response)
    } catch (error) {
        throw `Ошибка при получении данных о результатах аудита \n ${error}`;
    }
}

const getAuditTest = async(auditTestId) =>{
    try {
        const response=await Api({
            method:"get",
            url:`/tests/@${auditTestId}`,
            headers:{}
        })
        return(response)
    } catch (error) {
        throw `Ошибка при получении данных о тесте аудита \n ${error}`;
    }
}

const FetchData = () => {
    const [loading, setLoading]=useState(false);
    const [error,setError]=useState(false);
    const [block,setBlock]=useState(false);

    const [errorInfo,setErrorInfo]=useState(null);
    const [data,setData]=useState(null);
    const [dataTest, setDataTest]=useState(null);

    const {audit_id}=useParams();

    const getResults = async() => {
        try {
            const response = await getAuditResults(audit_id);
            const responseTest=await getAuditTest(response.data.test_id);
            setData(response.data);
            setDataTest(responseTest.data);
            setBlock(true);
        } catch (error) {
            setError(true);
            setErrorInfo(error)
        }
    }

    useEffect(()=>{
        const setUp = async() => {
            setLoading(true);
            await getResults();
            setLoading(false);
        }
        setUp();
    },[])

    if (loading){return(<LoadingStuck/>)}
    if(error){return(<p className="warning_text">{errorInfo}</p>)}
    if(block){return(<AuditResultsInterface data={data} dataTest={dataTest}/>)}
}

const AuditResultBlock = () => {
    return(<FetchData/>)
}

export default AuditResultBlock;